import {
  FILE_UPLOAD_MEGABYTE_LIMIT,
  UPLOAD_PAYLOAD_LIMIT_BINARY
} from "src/constants/limits";
import type { TranslationKey } from "src/types/translationKey";

export interface FileValidationError {
  key: TranslationKey;
  variables: Record<string, unknown>;
}

/**
 * nginx rejects request bodies over the limit with a CORS-less 413 that the
 * browser cannot read, so oversize files have to be caught client-side.
 */
export const fileUploadLimitError = (
  file: File
): FileValidationError | null => {
  if (file.size <= UPLOAD_PAYLOAD_LIMIT_BINARY) {
    return null;
  }

  return {
    key: "leapChat.attachment.fileTooLarge",
    variables: { maxSize: `${FILE_UPLOAD_MEGABYTE_LIMIT} MB` }
  };
};
